import { render, staticRenderFns } from "./user_chats.vue?vue&type=template&id=e1fe40a6&scoped=true&"
import script from "./user_chats.vue?vue&type=script&lang=js&"
export * from "./user_chats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fe40a6",
  null
  
)

export default component.exports